export default __webpack_public_path__ + "static/media/screenBlock5.7709c8cd.jpg";